module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fb-Gc-Hc-Id-Ja.593ff588.png";